define('v3/Common/Components/Chat/Chat.Component',[
	'knockout',
	'jquery',
	'env',
	'v3/Common/Services/Backend/chatBackend',
	'text!v3/Common/Components/Chat/Chat.Component.html'
], function (ko, $, env, chatBackend, htmlString) {
	function ChatViewModel (params) {
		var self = this;

		var firstTime = true;
		var pollStartTime;
		var pollInterval = 30 * 1000;

		self.isSaving = ko.observable(false);
		self.shouldTryAgainLater = ko.observable(false);
		self.noCreateChatAvailable = ko.observable(false);
		self.isFirstTimeShowing = params.isFirstTimeShowing;

		self.cancel = function () {
			self.modal.close();
		};

		self.ok = function () {
			self.isSaving(true);

			if (!self.loader) {
				self.loader = $.Deferred();
				self.modal.reloadLoader();
			}

			chatBackend.createChat(env.userInfo.classId, env.userInfo.className)
				.done(function (data) {
					if (!data) {
						self.isSaving(false);
						self.loader.resolve();
						self.loader = undefined;
						return;
					}

					self.modal.close(data);
				})
				.fail(function (jqXHR) {
					if (jqXHR.status === 503) {
						if (firstTime) {
							firstTime = false;
							pollStartTime = new Date().getTime();
							self.ok();
						} else if ((pollStartTime + pollInterval) > new Date().getTime()) {
							self.ok();
						} else {
							self.shouldTryAgainLater(true);
							self.loader.resolve();
							self.loader = undefined;
						}
					} else if (jqXHR.status === 418) {
						self.isSaving(false);
						self.noCreateChatAvailable(true);
						self.loader.resolve();
						self.loader = undefined;
					} else {
						self.isSaving(false);
						self.loader.resolve();
						self.loader = undefined;
					}
				});
		};
	}

	return { viewModel: ChatViewModel, template: htmlString };
});
